import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
	path: '/',// 路径为‘/’时跳转到 path: '/Login',
	redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/page/login/login')
  },{
    path: '/VerificationCodeLogin',
    name: 'VerificationCodeLogin',
    component: () => import('@/page/login/VerificationCodeLogin')
  },{
    path: '/register',
    name: 'register',
    component: () => import('@/page/login/register')
  },{
    path: '/home',
    name: 'home',
    component: () => import('@/page/home/home')
  },{
    path: '/Repaymenthome',
    name: 'Repaymenthome',
    component: () => import('@/page/home/Repaymenthome')
  },{
    path: '/Repaymenthome2',
    name: 'Repaymenthome2',
    component: () => import('@/page/home/Repaymenthome2')
  },{//还款方式
	 path: '/Repaymentchannel',
	 name: 'Repaymentchannel',
	 component: () => import('@/page/home/Repaymentchannel') 
  },{//还款支付页
	path: '/Repaymentpayment',
	name: 'Repaymentpayment',
	component: () => import('@/page/Repayment/Repaymentpayment') 
  },{//贷款页面
	path: '/Loanpage',
	name: 'Loanpage',
	component: () => import('@/page/home/Loanpage')
  },{//认证页面
	path: '/AuthenticationPage',
	name: 'AuthenticationPage',
	component: () => import('@/page/authentication/AuthenticationPage')  
  },{//认证页面审核未通过
	  path: '/Reviewfailed',
	  name: 'Reviewfailed',
	  component: () => import('@/page/authentication/Reviewfailed')  
  },{
	  //学历认证
	  path: '/Educationcertification',
	  name: 'Educationcertification',
	  component: () => import('@/page/authentication/Educationcertification')
  },{//银行信息
	path: '/BankInformation',
	name: 'BankInformation',
	component: () => import('@/page/authentication/BankInformation')
  },{//页面认证
	  path: '/IdentityAuthentication',
	  name: 'IdentityAuthentication',
	  component: () => import('@/page/authentication/IdentityAuthentication'),
	  meta:{keepAlive:false}
  },{
	  path: '/Facerecognition',
	  name: 'Facerecognition',
	  component: () => import('@/page/Facerecognition/Facerecognition')
  },{ //等待页
	  path: '/Waitingpage',
	  name: 'Waitingpage',
	  component: () => import('@/page/Waitingpage/Waitingpage')
  }
]

const router = new VueRouter({
  routes
})

export default router